import {ViewIdentifiable} from "../../models/common/ViewSettings";
import {ErrorAction, ReduxAction} from "../../models/common/ActionTypes";
import {ApiReturnType, getUserViewSettingsApiRequest} from "../../models/common/ApiReturnType";
import {AppState} from "../../reducers/RootReducer";
import {APP_CONFIG} from "../../config/GeneralConfig";
import {eventNotificationError, eventNotificationSuccess} from "../common/EventNotificationActions";
import {
    ContractorOffice
} from "../../models/contractor/ContractorOffice";

import {  ofType, StateObservable } from "redux-observable";
import { switchMap, map, catchError } from "rxjs/operators";
import { ajax } from "rxjs/ajax";
import { Observable, of } from 'rxjs';
import {Nullable} from "../../models/common/Nullable";
import {ContractorId} from "../../models/contractor/Contractor";
import {Identifier} from "../../models/common/Identifier";

/**
 * base API path to interact with project roles
 */
function apiPath( contractorId: number, id: Nullable<number> = null ): string {
    return APP_CONFIG.baseWeb + "contractors/"+ contractorId +"/offices/"+ ( id !== null ? id : '');
}

/** union of all project role actions types */
export type ContractorOfficeActionTypes = FetchContractorOfficesActionTypes

/**
 * FETCH CONTRACTORS_OFFICES BY USER VIEW SETTINGS
 *
 * user view settings will automatically be retrieved from redux store
 */
// TYPESCRIPT REDUX ACTION TYPES
export interface FetchContractorOfficesAction extends ViewIdentifiable, ContractorId, ReduxAction< typeof FETCH_CONTRACTORS_OFFICES > {}
export interface FetchContractorOfficesSuccessAction extends ContractorId, ViewIdentifiable, ReduxAction<typeof FETCH_CONTRACTORS_OFFICES_SUCCESS > {
    payload: ApiReturnType< ContractorOffice[] >
}
export interface FetchContractorOfficesErrorAction extends ContractorId, ViewIdentifiable, ErrorAction< typeof FETCH_CONTRACTORS_OFFICES_ERROR >{}

export type FetchContractorOfficesActionTypes = FetchContractorOfficesAction
    | FetchContractorOfficesErrorAction
    | FetchContractorOfficesSuccessAction

// REDUX ACTION TYPE CONSTANTS
export const FETCH_CONTRACTORS_OFFICES = "FETCH_CONTRACTORS_OFFICES";
export const FETCH_CONTRACTORS_OFFICES_SUCCESS = "FETCH_CONTRACTORS_OFFICES_SUCCESS";
export const FETCH_CONTRACTORS_OFFICES_ERROR = "FETCH_CONTRACTORS_OFFICES_ERROR";

// REDUX ACTION ACCESSORS FUNCTIONS
export function fetchContractorOffices( contractorId: Identifier<number>, viewIdentifier: string ) : FetchContractorOfficesAction {
    return { type: FETCH_CONTRACTORS_OFFICES, viewIdentifier, contractorId };
}
export function fetchContractorOfficesSuccess(
    contractorId: Identifier<number>,
    viewIdentifier: string,
    payload: ApiReturnType< ContractorOffice[] >
) : FetchContractorOfficesSuccessAction
{
    return { type: FETCH_CONTRACTORS_OFFICES_SUCCESS, viewIdentifier, payload, contractorId };
}
export function fetchContractorOfficesError(
    contractorId: Identifier<number>,
    viewIdentifier: string,
    error: Error
): FetchContractorOfficesErrorAction {
    return { type: FETCH_CONTRACTORS_OFFICES_ERROR, viewIdentifier, error, contractorId };
}

// REDUX OBSERVABLE EPIC
export function fetchContractorOfficesEpic(
    action$: Observable< FetchContractorOfficesAction >,
    store$: StateObservable< AppState >
) {
    return action$.pipe(
        ofType( FETCH_CONTRACTORS_OFFICES ),
        switchMap( action => {
            const request = getUserViewSettingsApiRequest(
                apiPath( action.contractorId.rawValue ),
                action.viewIdentifier,
                store$
            );

            return ajax( APP_CONFIG.getRequestObject(request.path) ).pipe(
                map( response => fetchContractorOfficesSuccess(
                    action.contractorId,
                    action.viewIdentifier,
                    response.response as ApiReturnType<ContractorOffice[]>
                ) ),
                catchError(error => of(
                    fetchContractorOfficesError( action.contractorId, action.viewIdentifier, error),
                    eventNotificationError(error, store$, action.viewIdentifier, "fetchContractorOffices")
                ))
            );

        })
    );
}
